import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workflowCreate } from '@api/sdk.gen';
import { WorkflowsCreatePayload } from '@api/types.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { workflowQueryKeys } from '../../queries/query-keys';

async function createWorkflow(payload: WorkflowsCreatePayload) {
  const { data } = await workflowCreate({ body: payload });

  return data;
}

export function useCreateWorkflow() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createWorkflow,
    ...withError('Unable to create workflow'),
    ...withInvalidate(queryClient, [workflowQueryKeys.all]),
  });
}
